module.exports = __webpack_public_path__ + "static/media/ico_rewards.791b7b77.png";